import React from 'react';
import { alpha, Box, Typography } from '@mui/material';

export function AgencyFilterGroupHeading({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        px: 1.5,
        py: 0.75,
        bgcolor: (t) => alpha(t.palette.primary.main, 0.06),
        borderTop: (t) => `1px solid ${t.palette.divider}`,
        borderBottom: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <Typography variant="caption" fontWeight={700} sx={{ textTransform: 'uppercase', letterSpacing: 0.02 }}>
        {children}
      </Typography>
    </Box>
  );
}

export function AgencyFilterSubHeading({ children }: { children: React.ReactNode }) {
  return (
    <Box sx={{ px: 2, py: 0.5, bgcolor: (t) => alpha(t.palette.grey[500], 0.06) }}>
      <Typography variant="body2" fontWeight={600}>
        {children}
      </Typography>
    </Box>
  );
}
